import { type Styles } from '@adornis/ass/style.js';
import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import { XToggleButton } from '@adornis/forms/x-toggle-button.js';
import { customElement } from 'lit/decorators.js';

/**
 * @customElement cr-toggle-button
 */
@customElement('cr-toggle-button')
export class ChromiumToggleButton extends XToggleButton {
  override styles = () =>
    [
      {
        ':host': { cursor: 'pointer', userSelect: 'none' },
        'div[togglewrapper]': {
          boxSizing: 'border-box',
          display: 'block',
          padding: '1px',
          border: `2px solid ${this.value.value ? this.colors.primary : this.colors.tone.error}`,
          borderRadius: `calc( ${this.spacing.sm} + 2px )`,
          width: `calc(2 * ${this.spacing.md} + 2px)`,
          transition: 'background-color .12s',
        },
        '[toggle]': {
          background: this.colors.tone.error,
          width: this.spacing.sm,
          height: this.spacing.sm,
          margin: this.spacing.xxs,
          borderRadius: `calc(${this.spacing.md} / 2)`,
          transition: 'transform .12s, background-color .12s',

          '&[toggled]': {
            height: `CALC( ${this.spacing.md} - 2px )`,
            width: `CALC( ${this.spacing.md} - 2px )`,
            background: this.colors.primary,
            margin: '1px',
            transform: `translateX( calc( 100% - 2px ) )`,
            [`${DesignSystem.prefix}-icon`]: {
              color: this.colors.on.accent,
            },
          },
          [`${DesignSystem.prefix}-icon`]: {
            color: this.colors.on.black,
            fontSize: this.baseFontSize,
          },
        },
        ':host([disabled])': { '[toggle]': { opacity: '.5' } },
      },
    ] as Styles[];
}
